/* eslint-disable react/jsx-no-useless-fragment */
import { ReactNode, useEffect } from 'react';

import { useAppContext } from '@frx/frx-react-context';
import { Navigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';

export type PrivateRouteProps = {
  children?: ReactNode;
};

export const PrivateRoute = ({ children }: PrivateRouteProps): JSX.Element => {
  const {
    data: {
      authData: { loggedIn, user },
    },
  } = useAppContext();

  useEffect(() => {
    Sentry.setUser({
      id: String(user?.cons_id),
      username: String(user?.user_name),
      email: String(user?.email?.primary_address),
    });
  }, [loggedIn, user?.cons_id, user?.email?.primary_address, user?.user_name]);

  return !loggedIn ? (
    <Navigate to="/login" />
  ) : loggedIn && !user?.isRegistered ? (
    <Navigate to="/login/not-registered" />
  ) : loggedIn && user?.isRegistered ? (
    <>{children}</>
  ) : (
    <></>
  );
};
